import React, { useEffect, useState } from "react";
import useAPI from "hooks/useAPI";
import useStripe from "hooks/useStripe";
const PaymentMethod = ({ bookingId }) => {
  const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(null);
  const { API } = useAPI({});
  const { addCard } = useStripe();
  useEffect(() => {
    getAndSetDefaultPaymentMethod();
  }, []);

  const getAndSetDefaultPaymentMethod = async () => {
    let data = await API.get("/stripe/default-payment-method");
    console.log("getAndSetDefaultPaymentMethod -> data", data);
    setDefaultPaymentMethod(data?.defaultPaymentMethod);
  };
  const ChangeCardBtn = () => {
    return (
      <span>
        &nbsp;
        <a
          onClick={() => {
            addCard(bookingId);
          }}
          className="text-sm font-black underline cursor-pointer text-blue-500"
        >
          (change)
        </a>
      </span>
    );
  };
  return (
    <div className="inline">
      {defaultPaymentMethod ? (
        <div className="inline text-black">
          <span className="uppercase">{defaultPaymentMethod.card.brand}</span>
          &nbsp;{defaultPaymentMethod.type}
          &nbsp;ending&nbsp;{defaultPaymentMethod.card.last4}
          {bookingId ? ( //Only allow change card if bookingId is passed in
            <ChangeCardBtn />
          ) : null}
        </div>
      ) : (
        <div className="inline">
          [RETRIEVING CARD DETAILS...]
          <ChangeCardBtn />
        </div>
      )}
    </div>
  );
};

export default PaymentMethod;
